var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ServicesHeader'),_c('span',{staticClass:"hidden-sm-and-down"},[_c('ServicesGrid')],1),_c('span',{staticClass:"hidden-md-and-up"},[_c('ServicesStairs')],1),_c('Areas'),_c('Allies'),_c('Customers'),_c('ContactForm'),_c('Map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }